import { SearchCriteriaStore, SearchFormStore, ErrorStore } from 'stores';
import { FlightAction } from '__generated__/api';
import JourneySearchCriteria = FlightAction.JourneySearchCriteria;

export const prepareStoresForAlternateSearch = (
  searchCriteriaStore: SearchCriteriaStore,
  searchFormStore: SearchFormStore,
  nextSearchCriteria: JourneySearchCriteria,
  errorStore: ErrorStore
) => {
  searchCriteriaStore.syncWithNextSearchCriteriaWithOD(nextSearchCriteria);
  searchCriteriaStore.clearSortFilterSearchCriteria();
  searchCriteriaStore.clearJourneysContinuationId();
  searchCriteriaStore.clearPagination();
  searchCriteriaStore.updateFlightsDisplayComponentCountingValue(errorStore.flightsDisplayComponentCountingValue);
  searchFormStore.syncJourneysWithSearchCriteriaStore(searchCriteriaStore);
};
